import * as React from "react";

import { Form, Button, Grid } from "semantic-ui-react";

import { QuestionProps, FileAnswer, AnsweredQuestion } from "../../model";
import { FileUpload } from "../../../fileUploads";
import { isQuestionDisabled } from "../../questionnaireConfig/models";

import { QuestionWrapper } from "./QuestionWrapper";

interface FileQuestionProps {
    api: string;
    acceptExtensions?: string[];
    onRemove?: () => void;
}

class FileQuestion extends React.Component<QuestionProps & FileQuestionProps> {
    public render() {
        const { questionConfig, mandatory, showError, api, readonly, hideDivider, children } = this.props;
        const answer = this.props.answer as FileAnswer;
        if (isQuestionDisabled(questionConfig)) {
            return null;
        }

        return (
            <QuestionWrapper
                question={questionConfig.questionText}
                mandatory={mandatory}
                hideDivider={hideDivider}
                error={showError && mandatory && !answer && "This field must be completed"}
                readonly={this.props.readonly}
                removable={{
                    ...this.props.removable,
                    questionId: this.props.questionConfig.id,
                    isRemovedByUser: this.props.isRemovedByUser
                }}
                outdated={{
                    ...this.props.outdated,
                    questionId: this.props.questionConfig.id
                }}
            >
                <Form.Field>
                    {readonly ?
                        <>
                            <a href={`${api}/${answer.blobId}?fileName=${answer.fileName}`} hidden={!answer.blobId}>
                                <Button content={answer.fileName} type="button" />
                            </a>
                            {children}
                        </>
                        :
                        <Grid columns="2">
                            <Grid.Column>
                                <FileUpload
                                    apiUrl={api}
                                    fileName={answer.fileName}
                                    onFileChange={(blobId, fileName) => this.changeFile(blobId, fileName)}
                                    acceptExtensions={this.props.acceptExtensions}
                                />
                            </Grid.Column>
                            <Grid.Column textAlign="right" verticalAlign="middle">
                                {this.props.onRemove && <Button content="Remove" type="button" onClick={this.props.onRemove} floated="right" />}
                            </Grid.Column>
                        </Grid>
                    }
                </Form.Field>
            </QuestionWrapper>
        );
    }

    private changeFile(blobId: string, fileName: string) {
        const { questionConfig, updateQuestion, onAnswerChange } = this.props;
        if (isQuestionDisabled(questionConfig)) {
            return;
        }

        const newQuestion: AnsweredQuestion = { question: questionConfig.questionText, answer: { blobId, fileName }, isValid: true };
        if (updateQuestion) {
            updateQuestion(newQuestion);
        }
        if (onAnswerChange) {
            onAnswerChange(newQuestion.answer);
        }
    }
}

export { FileQuestion };
